import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import PageScrollHandler from './PageScrollHandler';

const Layout: React.FC = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <PageScrollHandler />
      <Navbar />
      <main className="flex-grow container mx-auto px-4 py-8 max-w-screen-2xl">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout; 